import PropTypes from 'prop-types';
import React from 'react';
import {intlShape} from 'react-intl';
import {connectToStores} from 'fluxible-addons-react';
import Actions from '../../../constants/Actions';
import Roles from '../../../constants/Roles';
import ProtectedComponent from '../../../components/ProtectedComponent';
import Unauthorized from '../../../pages/Unauthorized';
import {PublicationShape} from '../../../utils/react/Shapes';
import PublishEnvironment from './PublishEnvironment';
import {setPendingPublish} from '../actions/PublishActionCreator';
import {NotificationManager} from 'react-notifications';

function alternative() {
  return <Unauthorized />;
}


@connectToStores(['PublishStore'], context =>
  ({
    publication: context.getStore('PublishStore').getPublication()
  })
)
  /**
   * For some reason, 'PublishingMain.js' can't be recognized as a js file, and that
   * makes coding a pain, so 'PublishMain' it is.
   */
class PublishMain extends React.Component {

  static propTypes = {
    publication: PublicationShape.isRequired,
    children: PropTypes.element
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  static async loadAction(context) {
    console.log('PublishMain:loadAction');
    const result = await context.service.read('publish', {});
    console.log('PublishMain:loadAction:result', result.data);

    context.dispatch(Actions.PUBLISH_LOAD_PUBLICATION, result.data);
  }

  constructor(props) {
    super(props);
  }

  togglePublishing = (envKey, pendingPublish) => {
    console.log('togglePublishing', envKey, pendingPublish);
    this.context.executeAction(setPendingPublish, {
      clientKey: this.props.publication.clientKey,
      environmentKey: envKey,
      pendingPublish: pendingPublish
    });
    NotificationManager.success(`Successfully scheduled publishing for ${envKey}.`);
  };

  render() {
    const {environments} = this.props.publication;
    const content = environments.map(e =>
      <div key={e.environmentKey} className='publish-env flex-element container flex-container flex-justify-center'>
        <PublishEnvironment env={e}
                            scheduleButtonClickHandler={this.togglePublishing}
        />
      </div>
    );

    return (
      <ProtectedComponent role={Roles.PUBLISHING} alternateComponent={alternative}>
        <main className='publish content form-container flex-container flex-element flex-vertical dashboard'>
          <h1 className='dashboard-header'>Publish</h1>
          <div className='dashboard-content'>
            {content}
          </div>
        </main>
      </ProtectedComponent>
    );
  }
}

export default PublishMain;



// WEBPACK FOOTER //
// ./src/apps/Publish/components/PublishMain.js